export function validMobileNetworks(startsWith) {
  const validNetworks = ['96', '97', '98', '91'];

  return validNetworks.find((f) => f === startsWith?.toString().trim());
}
